import { render } from "./TheBasement.vue?vue&type=template&id=230e789b&scoped=true"
import script from "./TheBasement.vue?vue&type=script&lang=js"
export * from "./TheBasement.vue?vue&type=script&lang=js"

import "./TheBasement.vue?vue&type=style&index=0&id=230e789b&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230e789b"]])

export default __exports__